import React from 'react';
import { Building2, Rss, Play, MoreHorizontal } from 'lucide-react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

const options = [
  'None',
  'Atria',
  'Callisto',
  'Umbriel',
];


function TableRow({ row, selected, onSelect ,setModalOpen , setSelectedContent ,setTitle}) {  
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCellClick = (value , title) => {
    setTitle(title)
    setSelectedContent(value);
    setModalOpen(true);
  };

  return (
    <tr className="table-row">
      <td>
        <input
          type="checkbox"
          checked={selected}
          onChange={() => onSelect(row?.ts)}
        />
      </td>
      <td>{row?.ts}</td>
      <td>{row?.AppName}</td>
      <td>{row?.Environment}</td>
      <td>{row?.Tenant}</td>
      <td>{row?.Endpoint}</td>
      <td>{row?.DurationMs}</td>
      <td>{row?.CallerIP}</td>
      <td>{row?.Identifier}</td>
      <td>{row?.APICallID}</td>
      <td  onDoubleClick={() => handleCellClick(row?.Headers , "Header")} style={{ cursor: 'pointer' }} >{row?.Headers?.split(':').slice(0, 2).join(':')}...</td>
      <td  onDoubleClick={() => handleCellClick(row?.Body , "Body")} style={{ cursor: 'pointer' }} >{row?.Body?.split(':').slice(0, 2).join(':')}...</td>
      {/* <td>
        <div className="row-actions">
          <Building2 className="action-icon" size={20} />
          <Rss className="action-icon" size={20} />
          <Play className="action-icon" size={20} />
          <MoreHorizontal 
              className="action-icon" aria-label="more"
              id="long-button"
              aria-haspopup="true"
              onClick={handleClick}
              size={20} />
          <Menu
            id="long-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            disableScrollLock={true} 
          >
            {options.map((option) => (
              <MenuItem key={option} onClick={handleClose}>
                {option}
              </MenuItem>
            ))}
          </Menu>
        </div>
      </td> */}
    </tr>
  );
}

export default TableRow;